import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IImageFilters, IImageFiltersData } from '../../../imageFilters.model';
import { FiltersDropdownRow } from '../FiltersDropdownRow';

interface IReviewedByFilterInfoProps {
  availableFilters: IImageFiltersData;
  imageFilters: IImageFilters;
}

export const ReviewedByFilterInfo = observer((props: IReviewedByFilterInfoProps): ReactElement => {
  const { t } = useTranslator();

  const selectedOptions = props.availableFilters.reviewedBy
    .slice()
    .sort((a, b) => (a.email > b.email ? 1 : -1))
    .filter((d) => props.imageFilters.reviewedBy.includes(d.id));

  return (
    <FiltersDropdownRow
      label={t('image_filters.reviewedBy')}
      count={selectedOptions.length}
    >
      <>
        {selectedOptions.map((d) => (
          <div key={d.id}>{d.email}</div>
        ))}
      </>
    </FiltersDropdownRow>
  );
});
